import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0038',
    ecrans: ['00-2']
});

